import React from "react";
import { useSelector } from "react-redux";

import { get } from "lodash";
import styled from "styled-components/macro";
import { ArrowRight } from "react-feather";
import { useBreakpoint } from "../../utilities/media-js-breakpoints";
import { getAppConfig, getLanguage, getSideMenuOpen, getFrontendSettings } from "../../store/sagas/selectors";
import Constants from "../../constants";

const ButtonContainer = styled.div<ContainerProps>`
    position: absolute;
    cursor: pointer;
    color: white;
    ${props => (props.isMobile ? "top: 10px" : "bottom: 25px")};
    right: ${props => (props.expanded ? props.sideMenuWidth : props.right)}px;
    z-index: 3;
    display: flex;
    flex-flow: column;
    align-items: center;
    font-size: 14px;
    transition: all 0.45s;
    ${({ theme }) => theme.bp.xxxl`
        transform: scale(1.85, 1.85);
        transform-origin: bottom right;
    `}
`;

const IconContainer = styled.div<IconProps>`
    background: ${({ theme }) => theme.buttonNext.backgroundColor};
    border-radius: 50%;
    width: ${props => (props.isMobile ? "35px" : "60px")};
    height: ${props => (props.isMobile ? "35px" : "60px")};
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 3px 10px 0 rgba(0, 0, 0, 0.2);
    transition: background 0.2s ease-in-out;
    @media (hover) {
        &:hover {
            background: ${({ theme }) => theme.buttonNext.hoverColor};
        }
        &:active {
            background: ${({ theme }) => theme.buttonNext.activeColor};
        }
    }
`;

const Text = styled.div`
    font-family: ${props => props.theme.fontFamily};
    text-shadow: #000 0px 1px 12px;
    padding-top: 10px;
    text-align: center;
`;

interface ContainerProps {
    sideMenuWidth: number;
    right: number;
    expanded: Boolean;
    isMobile: Boolean;
}

interface IconProps {
    isMobile: Boolean;
}

export const ButtonNext = ({ menuSideRight, onClick }: { menuSideRight: Boolean; onClick: Function }) => {
    const breakpoints = useBreakpoint();
    const isOpen: boolean = useSelector(getSideMenuOpen);
    const appConfig = useSelector(getAppConfig);
    const language = useSelector(getLanguage);
    const frontendSettings = useSelector(getFrontendSettings);

    const hideNavigationButtonsSetting = frontendSettings?.hide_navigation_buttons;
    const searchParams = new URLSearchParams(window.location.search);
    const param = searchParams.get(Constants.hideNavigationButtonsQueryParam);
    const hideNavigationButtons = param !== null ? JSON.parse(param) : hideNavigationButtonsSetting;

    if (hideNavigationButtons) {
        return null;
    }

    const isHighRes = breakpoints.xxxl ? Constants.highResSideMenuWidth + 60 : Constants.sideMenuWidth + 60;
    const isMobileOrTablet = breakpoints.sm || breakpoints.xs ? 10 : 60;
    const isMobile = breakpoints.sm || breakpoints.xs;

    const buttonText = get(appConfig, `translations.${language}.continue`);
    return (
        <ButtonContainer
            sideMenuWidth={isHighRes}
            right={isMobileOrTablet}
            expanded={isOpen && menuSideRight && !isMobile}
            isMobile={isMobile}
            onClick={() => onClick()}
        >
            <IconContainer isMobile={isMobile}>
                <ArrowRight color="white" />
            </IconContainer>
            {!breakpoints.xxs && !breakpoints.xs && !breakpoints.sm ? <Text>{buttonText}</Text> : null}
        </ButtonContainer>
    );
};
